import Controller from '@ember/controller';
import { computed, get, getProperties, set } from '@ember/object';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  store: service(),
  router: service(),

  errorMessage: null,

  reset() {
    set(this, 'errorMessage', null);
  },

  hasMultipleFunds: computed('model.funds.[]', function () {
    return get(this, 'model.funds.length') > 1;
  }),

  fundsOptions: computed('model.funds.[]', function () {
    return sortByProperties(get(this, 'model.funds'), ['name']).map((fund) => {
      return {
        val: get(fund, 'id'),
        label: get(fund, 'name'),
      };
    });
  }),

  mailchimpListOptions: computed(
    'model.mailchimpSetting.lists.[]',
    function () {
      return sortByProperties(get(this, 'model.mailchimpSetting.lists'), [
        'name',
      ]).map((list) => {
        return {
          val: get(list, 'id'),
          label: get(list, 'name'),
        };
      });
    },
  ),

  save: task(function* () {
    try {
      yield this.fundsService.confirmValidFundToken();
      let changeset = get(this, 'model.changeset');
      let record = this.store.createRecord(
        'mailchimp-fund-setting',
        getProperties(
          changeset,
          'mailchimpSettingId',
          'fundId',
          'mailchimpListId',
        ),
      );
      yield record.save();
      this.router.transitionTo(
        'funds.fund.more.mailchimp.new-connected-to-fund',
      );
    } catch (e) {
      set(
        this,
        'errorMessage',
        "Whoops! There was an error saving. Sorry about that. Please email us at support@donorelf.com to let us know and we'll get it fixed",
      );
    }
  }).drop(),
});
